import { SwDerivedApiStore } from "@sourcewhale/shared/src/svelte/api-stores/sw-api-store";
import { queryCalls } from "@sourcewhale/shared/src/svelte/api/calls";
import { callsQueryParamsStore } from "./callsQueryParams.svelte";

export const getCallsQueryStore = () =>
  SwDerivedApiStore({
    get: queryCalls,
    init: () => ({ data: [] }),
    argsTransform: (data) => {
      if (!data) return null;

      const columns = data.columns.map((c) => {
        const { searchable = true, orderable = false, name } = c;
        const col = {
          data: typeof c.data === "string" ? c.data : "function",
          searchable,
          orderable,
          name,
        };
        if (searchable) {
          col.search = { value: "", regex: false };
        }
        return col;
      });

      return [
        {
          draw: 0,
          ...data,
          columns,
        },
      ];
    },
    argsStore: callsQueryParamsStore,
    debounceDelayMs: 100,
    rateLimitMs: 1000,
    concurrencyStrategy: "skipOutOfOrderResponses",
  });
